import styled from "styled-components"

export default styled.div`
  border-radius: 5px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 10px;
  font-weight: 600;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  width: fit-content;
`
